<template>
	<transition name="slide-down" >
		<div v-if="user">
			<div
				class="alert"
				:class="alertType"
				v-if="menuAlert"
				v-html="menuAlert"
			/>
		</div>
		<!--<banner-top v-else />-->
		<div v-else>
			<div
				class="alert"
				:class="'warning'"
				style='padding: 5px 0'
			>
			<b>Per ordinare la tua spesa accedi o registrati</b>
			</div>

		</div>	
	</transition>
</template>

<script type="text/javascript">

import BannerTop from '../Parts/BannerTop'

export default {
	components: {
		BannerTop
	},
	props: {
		menu: {
			type: Object,
			default () {
				return null
			}
		},
		loadingMenu: {
			type: Boolean,
			default: false
		},
		message: {
			type: String,
			default: null
		},
		type: {
			type: String,
			default: null
		}
	},

	computed: {
		user () {
			return this.$root.user
		},
		
		menuAlert () {
			return this.message ? this.message : this.menu && this.menu.alert && this.menu.alert.message
		},

		alertType () {
			return this.type ? this.type : this.menu && this.menu.alert && this.menu.alert.type
		}
	}
}

</script>

<style scoped>

.alert {
	margin-bottom: 0;
	background-color: white;
	width: 100%;
	border: 1px solid #ededed;
	color: black;
	border-radius: 0;
	text-align: center;
	font-size:13px;
}

.alert.danger {
	color: #721c24;
	background-color: #f8d7da;
	border-color: #f5c6cb;
}

.alert.success {
	color: #155724;
	background-color: #e9f3d3;
	border-color: #c3df86;
}

.alert.warning {
	color: #856404;
	background-color: #fff3cd;
	border-color: #ffeeba;
}

.alert.info {
	color: #0c5460;
	background-color: #d1ecf1;
	border-color: #bee5eb;
}
</style>
